module.exports = __webpack_public_path__ + "img/infrastructure-17.05db3236.png";